import {
  SkeletonBodyText,
  Box,
  ResourceList,
  ResourceItem,
  Divider,
} from '@shopify/polaris';

import styles from '../../Navigation.scss';

export function NavigationSkeleton({withFilter = false}) {
  return (
    <div className={styles.NavigationWrapper}>
      <Box background="bg-surface">
        {withFilter && (
          <>
            <Box padding="400">
              <SkeletonBodyText lines={1} />
            </Box>
            <Divider />
          </>
        )}
        <ResourceList
          loading
          items={Array.from({length: 13}).map((_, index) => ({
            id: index,
          }))}
          renderItem={(_item, id) => {
            return (
              <ResourceItem
                id={id}
                onClick={() => null}
                verticalAlignment="center"
              >
                <Box>
                  <span className={styles.ItemName}>
                    <SkeletonBodyText lines={1} />
                  </span>
                </Box>
              </ResourceItem>
            );
          }}
          selectedItems={[]}
        />
      </Box>
    </div>
  );
}
